module.exports = __webpack_public_path__ + "img/china_broadnet_icon.7a6d982a.png";